// Helper functions
import { patchDataAsync, postDataAsync } from "helpers/_api";

// Config for API urls used in this vue template
import { config, apiHostname } from "config";

export const setWorkflowpropertyfield = (workflowcardData, card_id, field, value, instant_callback = false) => {
	return new Promise((resolve, reject) => {

		// Set is_json Y based on if value is array and has multiple instances + stringify the value
		let is_json = "N";
		if (Array.isArray(value)) {
			if (value.length > 1) {
				value = JSON.stringify(value);
				is_json = "Y";
			} else {
				value = value[0];
			}
		}

		const targetProperty = workflowcardData.extra.workflowproperties.find(a => a.field.id == field.id);
		if (targetProperty) {
			// If value is the same just return false, we don't need to change
			if (targetProperty.value == value) {
				return resolve(false);
			}

			// Store our value
			patchDataAsync(`${apiHostname}/${config.value.workflowproperty.url}/${targetProperty.id}`, { value: value, is_json: is_json }).then(result => {
				const newData = JSON.parse(JSON.stringify(result));
				if (newData.data.is_json == "Y") {
					// Try catch
					try {
						// If we have a JSON value, we parse it
						if (typeof newData.data.value === "string") {
							newData.data.value = JSON.parse(newData.data.value);
						}
					} catch (e) {
						console.error("Error parsing JSON value:", e);
					}
				}
				// Now we store our result in our workflowcardData again
				Object.assign(targetProperty, newData.data);
			}).then(result => {
				if (!instant_callback) {
					return resolve(true); // Defines if we made changes
				}
			});
			if (instant_callback) {
				return resolve(true);
			}
		} else if (value) {
			// We have value and it didn't yet exist, we should post
			postDataAsync(`${apiHostname}/${config.value.workflowproperty.url}`, {
				"value": value,
				"workflowcard_id": card_id,
				"workflowpropertyfield_id": field.id,
				"is_json": is_json
			}).then(result => {
				const newData = JSON.parse(JSON.stringify(result));
				if (newData.data.is_json == "Y") {
					// Try catch
					try {
						// If we have a JSON value, we parse it
						if (typeof newData.data.value === "string") {
							newData.data.value = JSON.parse(newData.data.value);
						}
					} catch (e) {
						console.error("Error parsing JSON value:", e);
					}
				}
				// Now we store our result in our workflowcardData again
				workflowcardData.extra.workflowproperties.push({
					id: newData.data.id,
					value: newData.data.value,
					field: {
						...field
					}
				});

				if (!instant_callback) {
					return resolve(true); // Defines if we made changes
				}
			});
			if (instant_callback) {
				return resolve(true);
			}
		} else {
			return resolve(false);
		}
	});
};